import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "create-btn" }

import { onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const createGroup = () => {
  console.log('创建群')
}
onMounted(() => {
})

return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_empty, {
        description: "暂无数据",
        image: require('@/assets/images/empty.png')
      }, null, 8, ["image"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        round: "",
        size: "large",
        icon: "Plus",
        style: {"background":"linear-gradient(to right, #9b2a5b, #ff7e5f)","border":"none"},
        onClick: createGroup
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("创建聊天室")
        ])),
        _: 1
      })
    ])
  ], 64))
}
}

})